export * from './ActorFunctionFactoryTermDay';
